<template>
  <div class="invoice_container" :style="`min-height:${mh}px`">
    <div class="part">
      <div class="rule_item invoice_info" v-if="dataSet" style="margin:0;">
        <div class="head_title"><div class="name">发票详情</div></div>
        <div class="rule_item_content">
          <Row class="items" :gutter="25">
            <Col :span="colSize[0]"><span class="title">发票号：</span><span class="value">{{dataSet.invoiceCode}}</span></Col>
            <Col :span="colSize[1]"><span class="title">发票时间：</span><span class="value">{{dataSet.invoiceTime | dataFormat('dateTime.short4')}}</span></Col>
            <Col :span="colSize[2]"><span class="title">创建时间：</span><span class="value">{{dataSet.createTime | dataFormat('dateTime.short4')}}</span></Col>
          </Row>
          <Row class="items" :gutter="25">
            <Col :span="colSize[0]"><span class="title">起运地：</span><span class="value">{{dataSet.exporter}}</span></Col>
            <Col :span="colSize[1]"><span class="title">出口人名称：</span><span class="value">{{dataSet.exporterName}}</span></Col>
            <Col :span="colSize[2]"><span class="title">出口人地址：</span><span class="value">{{dataSet.exporterAddress}}</span></Col>
          </Row>
          <Row class="items" :gutter="25">
            <Col :span="colSize[0]"><span class="title">目的地：</span><span class="value">{{dataSet.importer}}</span></Col>
            <Col :span="colSize[1]"><span class="title">收货人名称：</span><span class="value">{{dataSet.consigneeName}}</span></Col>
            <Col :span="colSize[2]"><span class="title">收货人地址：</span><span class="value">{{dataSet.consigneeAddress}}</span></Col>
          </Row>
        </div>
      </div>
      <div class="table_list" v-if="dataSet.projects">
        <Table :columns="tableColumns" :data="dataSet.projects" no-data-text="暂无记录"></Table>
      </div>
      <div class="rule_item resource" v-if="dataSet.files">
        <div class="head_title"><div class="name">证书列表</div></div>
        <Row class="items" v-if="dataSet.files.length === 1">
          <Col span="24" class="item">
            <div class="dw" @click.prevent="onDownload(dataSet.files[0].resource)" style="width: 84px;">
              <img src="~@/assets/images/coo/image_zhengshu.png" style="width:48px;height:auto;display:block;margin:0 auto;">
              <div class="title"><span>生成证书</span></div>
            </div>
          </Col>
        </Row>
        <Row class="items" :gutter="25" v-else>
          <Col span="4" v-for="resourceItem in dataSet.files" :key="resourceItem.id">
            <div class="dw" @click.prevent="onDownload(resourceItem.resource)">
              <img :src="resourceItem.sample" :title="resourceItem.name">
              <div class="title"><span>立即下载</span></div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RulesDecideDetailShow',
  props: {
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    mh: {
      type: Number
    }
  },
  data () {
    return {
      tableColumns: [
        {title: '项目编号', key: 'pn', align: 'center'},
        {title: '成品商品编码', key: 'goodsCode', align: 'center'},
        {title: '成品单价', key: 'goodsPrice', align: 'center'},
        {title: '成品数量', key: 'goodsCount', align: 'center', render: (h, params) => h('span', params.row.goodsCount || '-')},
        {title: '种类', key: 'type', align: 'center'},
        {title: '原产地标准', key: 'rule', align: 'center'},
        {title: '包装件数', key: 'packageCount', align: 'center'},
        {title: '毛重', key: 'grossWeight', align: 'center'},
        {title: '其他数量', key: 'otherNum', align: 'center'}
      ]
    }
  },
  computed: {
    colSize () {
      let screenWidth = document.body.clientWidth
      if (screenWidth < 1280) {
        return [6, 9, 9]
      } else if (screenWidth < 1600) {
        return [5, 7, 12]
      } else {
        return [4, 6, 14]
      }
    }
  },
  methods: {
    onDownload (url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style scoped>
  .invoice_container{
    background-color: #fff;
    padding: 28px 24px 42px;
  }
  .invoice_info.rule_item .rule_item_content{
    padding: 16px 0;
  }
  .invoice_info.rule_item .items{
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .invoice_info.rule_item .items >>> .ivu-col{
    display: flex;
  }
  .invoice_info.rule_item .items .title{
    color: #333;
    white-space: nowrap;
  }
  .invoice_info.rule_item .items .value{
    color: #999;
    font-weight: normal;
  }
  .table_list{
    margin-top: 20px;
    position: relative;
  }
  .table_list >>> .ivu-table-wrapper{
    border: 0 none;
    box-shadow: 0 2px 4px 0 rgba(196,196,196,0.50);
  }
  .table_list >>> .ivu-table{
    color: #333;
  }
  .table_list >>> .ivu-table th{
    background-color: #F9F9F9;
    font-size: 12px;
    font-weight: normal;
    border-color: #F1F1F1;
  }
  .table_list >>> .ivu-table td{
    font-size: 13px;
    border-color: #F1F1F1;
  }
  .table_list >>> .ivu-table .ivu-checkbox-wrapper{
    margin-right: 0;
  }
  .table_list >>> .ivu-table .tb_select .ivu-table-cell{
    padding-right: 0;
  }
  .table_list >>> .ivu-table .tb_company .ivu-table-cell{
    padding-left: 0;
  }
  .table_list >>> .ivu-table .opr a.line2:after{
    /*text-decoration: underline;*/
    bottom: 0;
  }
  .rule_item{
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    background-color: #fff;
    margin: 20px 0 0;
  }
  .rule_item .head_title{
    position: relative;
    height: 48px;
    line-height: 48px;
    background-color: #F9F9F9;
  }
  .rule_item .head_title .name{
    font-size: 14px;
    color: #333;
    background: url("~@/assets/images/icons/show/guide.png") 15px center no-repeat transparent;
    background-size: 4px 12px;
    padding-left: 26px;
  }
  .rule_item .head_title .name span{
    color: #1F8AFD;
    padding-left: 5px;
  }
  .rule_item .head_title .desc{
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #949494;
    background: url("~@/assets/images/coo/icon_tixing.png") 0 center no-repeat transparent;
    background-size: 12px auto;
    padding-left: 17px;
  }
  .rule_item .items{
    padding: 16px 18px;
    color: #333;
  }
  .rule_item .items .line{
    border-right: 1px dashed #ccc;
  }
  .rule_item .items .item .item_rule:first-child{
    margin-bottom: 12px;
  }
  .rule_item .items .value{
    font-weight: bold;
  }
  .part .resource .dw{
    /*width: 150px;*/
    /*height: 212px;*/
    text-align: center;
    cursor: pointer;
  }
  .part .resource .dw:hover .title span{
    text-decoration: underline;
  }
  .part .resource .dw img{
    width: 150px;
    height: 212px;
  }
  .part .resource .dw .title{
    color: #1F8AFD;
    font-size: 13px;
    margin: 8px 0 10px;
    max-width: 150px;
  }
  .part .resource .dw .title span{
    background: url("~@/assets/images/coo/icon_xiazai.png") no-repeat 0 center transparent;
    background-size: 14px;
    padding-left: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/CertShow.vue